import { RenderAttributeProps } from '../types';
import React from 'react';
import {
    ensureIsArray,
    ensureIsNumber,
    ensureIsString,
    ensureObjectLittle,
    getUnknownProperty,
} from '../../utils/ensure';
import { getUri, jFileLittle } from 'jamespot-user-api';
import { WidgetOption } from '../displayer.utils';
import { commonComponentsRegistry } from '../../registry/CommonRegistry';

export function DisplayDate({ object, attribute }: RenderAttributeProps) {
    const Date = commonComponentsRegistry.getLazyComponent('Date');
    const Typography = commonComponentsRegistry.getLazyComponent('Typography');

    const date = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(date)) return null;

    return (
        <Typography>
            <Date date={date} />
        </Typography>
    );
}

export function DisplayDateTime({ object, attribute }: RenderAttributeProps) {
    const Date = commonComponentsRegistry.getLazyComponent('Date');
    const Typography = commonComponentsRegistry.getLazyComponent('Typography');

    const date = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(date)) return null;

    return (
        <Typography>
            <Date date={date} format={'date-time'} />
        </Typography>
    );
}

export function DisplayDefault({ object, attribute }: RenderAttributeProps) {
    const Typography = commonComponentsRegistry.getLazyComponent('Typography');

    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(property) && !ensureIsNumber(property)) return null;

    return <Typography>{property}</Typography>;
}

export function DisplayEmail({ object, attribute }: RenderAttributeProps) {
    const StyledHref = commonComponentsRegistry.getLazyComponent('StyledHref');
    const Typography = commonComponentsRegistry.getLazyComponent('Typography');

    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(property)) return null;

    return (
        <Typography>
            <StyledHref href={`mailto:${property}`}>{property as string}</StyledHref>
        </Typography>
    );
}

export function DisplayFile({ object, attribute }: RenderAttributeProps) {
    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsArray(property)) return null;

    return (
        <ul>
            {(property as jFileLittle[]).map((file) => (
                <li key={file.uri}>{file.title}</li>
            ))}
        </ul>
    );
}

export function DisplayImage({ object, attribute }: RenderAttributeProps) {
    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsArray(property)) return null;

    if ('image' === attribute.name) {
        return <img src={`/imagecache/fitx600/${object.type}/${object.id}.png`} />;
    }

    return null;
}

export const DisplayRadio =
    (options: WidgetOption[]) =>
    // eslint-disable-next-line react/display-name
    ({ object, attribute }: RenderAttributeProps) => {
        const property = getUnknownProperty(object, attribute.name);
        if (!ensureIsString(property)) return null;

        const option = options.find((f) => f.value === property);
        if (!option) return null;

        return <>{option.label}</>;
    };

export function DisplayRichText({ object, attribute }: RenderAttributeProps) {
    const Html = commonComponentsRegistry.getLazyComponent('Html');

    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(property)) return null;

    return <Html as="p" __html={property} />;
}

export function DisplayTag({ object, attribute }: RenderAttributeProps) {
    const Tag = commonComponentsRegistry.getLazyComponent('Tag');

    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsArray(property) || !property.length) return null;

    return (
        <>
            {property.filter(ensureObjectLittle).map((value) => (
                <Tag key={value.uri} uri={getUri(value)} label={value.title} />
            ))}
        </>
    );
}

export function DisplayUrl({ object, attribute }: RenderAttributeProps) {
    const StyledHref = commonComponentsRegistry.getLazyComponent('StyledHref');
    const Typography = commonComponentsRegistry.getLazyComponent('Typography');

    const property = getUnknownProperty(object, attribute.name);
    if (!ensureIsString(property)) return null;

    return (
        <Typography>
            <StyledHref href={property}>{property}</StyledHref>
        </Typography>
    );
}
